const communities = [
  { name: "Mendenhall Valley", zip: "99801" },
  { name: "Auke Bay", zip: "99821" },
  { name: "Lemon Creek", zip: "99801" },
  { name: "Douglas", zip: "99824" },
  { name: "North Douglas", zip: "99824" },
  { name: "Thane", zip: "99801" },
  { name: "Glacier Highway", zip: "99821" },
  { name: "Twin Lakes", zip: "99801" },
  { name: "Montana Creek", zip: "99821" },
  { name: "Egan Drive Corridor", zip: "99801" },
  { name: "Haines (by ferry)", zip: "99827" },
  { name: "Skagway (by ferry)", zip: "99840" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Juneau &amp; All of Southeast Alaska
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Fast Passport Center serves Juneau and the entire Southeast Alaska panhandle including the City and Borough of Juneau, Douglas Island, and communities reachable by ferry. Alaska residents can ship their documents to our registered office for expedited passport processing — no Seattle agency trip required.
            </p>
            <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6">
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">Nearest Passport Agency</h3>
              <p className="text-gray-600 text-sm mb-2">
                <strong>Seattle Passport Agency</strong> — 915 2nd Ave, Seattle, WA 98174
              </p>
              <p className="text-gray-500 text-sm mb-2">
                Distance from Juneau: Requires flight — no road connection to the lower 48.
              </p>
              <p className="text-gray-500 text-sm">
                Fast Passport Center eliminates this trip entirely.
              </p>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-5">
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">Southeast Alaska Coverage</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We process passports for residents throughout Juneau (99801, 99811, 99821, 99824), Mendenhall Valley, Douglas, and Southeast Alaska communities including those served by the Alaska Marine Highway ferry system.
              </p>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-[#1A365D] mb-5">Communities We Serve</h3>
            <div className="grid grid-cols-2 gap-3">
              {communities.map((c, i) => (
                <div key={i} className="bg-white border border-gray-200 rounded-lg px-4 py-3 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-[#F6C344] text-sm"></i>
                    </div>
                    <span className="text-sm font-semibold text-[#1A365D]">{c.name}</span>
                  </div>
                  <span className="text-xs text-gray-400">{c.zip}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}